import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  standalone: true,
  template: '<div class="h-4 bg-primary-25 z-[999]"></div>',
})
export class FooterComponent {}
